import { useCallback, useEffect, useRef, useState } from 'react'

import { Carousel } from '@hhgtech/hhg-components/mantine'
import { Flex } from '@mantine/core'
import throttle from 'lodash/throttle'

import { fastdom } from 'utils/fastdom'

import { _Badge } from './_badge'
import { StyledContainer } from './index.styled'

export type Props = {
  spotLights: {
    name: string
  }[]
  isMobile: boolean
  isSponsored?: boolean
  applyH1?: boolean
}
const SpotlightList = ({
  spotLights,
  isMobile,
  isSponsored,
  applyH1,
}: Props) => {
  const onSelect = (name: string) => {
    fastdom.measure(() => {
      const element = document.querySelector(`[data-name="${name}"]`)
      if (element) {
        const headerOffset = isMobile ? 32 : 185
        const offsetPosition =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'auto',
        })
      }
    })
  }

  const [isCollapsed, setIsCollapsed] = useState(false)
  const scrollY = useRef(47)
  const collapsedMenu = useRef<boolean>(false)
  const isBrowser = typeof window !== 'undefined'
  const scrolling = useCallback(
    throttle(() => {
      const container = window
      if (
        isBrowser &&
        container &&
        container.scrollY > scrollY.current &&
        !collapsedMenu.current
      ) {
        collapsedMenu.current = true
        setIsCollapsed(true)
      }

      if (
        isBrowser &&
        container &&
        container.scrollY < scrollY.current &&
        collapsedMenu.current
      ) {
        collapsedMenu.current = false
        setIsCollapsed(false)
      }

      isBrowser &&
        container &&
        container.scrollY >= 0 &&
        (scrollY.current = container.scrollY)
    }, 300),
    [],
  )

  useEffect(() => {
    isMobile && scrolling()
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', scrolling, { passive: true })
    return () => {
      window.removeEventListener('scroll', scrolling)
    }
  }, [])

  return spotLights.length > 0 ? (
    <StyledContainer
      data-is-collapsed={isCollapsed}
      data-is-sponsored={isSponsored}
      fluid
    >
      {isMobile ? (
        <Carousel
          dragFree
          draggable
          slideSize={0}
          withControls={false}
          withIndicators={false}
          slideGap={8}
        >
          {spotLights.map((spotLight, index) => (
            <Carousel.Slide key={index}>
              <_Badge
                index={index}
                name={spotLight.name}
                onSelect={onSelect}
                applyH1={applyH1 && index === 0}
              />
            </Carousel.Slide>
          ))}
        </Carousel>
      ) : (
        <Flex gap={8} justify="center">
          {spotLights.map((spotLight, index) => (
            <_Badge
              key={index}
              index={index}
              name={spotLight.name}
              onSelect={onSelect}
              applyH1={applyH1 && index === 0}
            />
          ))}
        </Flex>
      )}
    </StyledContainer>
  ) : null
}

export { SpotlightList }
